<script setup>
import { computed, unref } from 'vue';
import { VCheckbox } from '../../components';
import OrderSummary from '@/modules/Signup/components/sign-up-form/OrderSummary.vue';
import { useSignUpModuleStore } from '@/stores/modules/signup/signUpStore';
import { storeToRefs } from 'pinia/dist/pinia';
import VModal from '@/modules/Signup/components/VModal.vue';
import { useModals } from '@/modules/Signup/composables/useModals';

const
    signUpStore = useSignUpModuleStore(),
    { termsAndConditions, agreements } = storeToRefs(signUpStore),
    { setAgreement } = signUpStore;

const { open, close, isOpen } = useModals();

function openTermModal(termId) {
    open(`term-modal-${termId}`);
}

function closeTermModal(termId) {
    close(`term-modal-${termId}`);
}

function createCheckboxModel(termId) {
    return computed({
        get: () => unref(agreements)[termId] || false,
        set: (value) => setAgreement(termId, value),
    });
}

// NOTE: As discussed w/ Carlito, there's no dependency with the selected terms.
</script>

<template>
    <div class="tw-flex tw-items-start tw-gap-x-20">
        <p v-if="termsAndConditions.length < 1">No terms and condition found, but you may still hit proceed by hitting
            submit.</p>
        <div v-else class="tw-flex-1 tw-grid tw-gap-5">
            <!-- This should be a dynamic agreement, i.e., don't use agreement_1 (???) -->
            <VCheckbox
                v-for="tac in termsAndConditions"
                :key="tac.term_and_condition_id"
                v-model="createCheckboxModel(tac.term_and_condition_id).value"
            >
                <button
                    type="button"
                    @click="openTermModal(tac.term_and_condition_id)"
                    class="tw-text-blue-600 hover:tw-text-blue-800 tw-underline tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0"
                >
                    {{ tac.name }}
                </button>

            </VCheckbox>
        </div>

        <OrderSummary />
    </div>

    <VModal
        v-for="tac in termsAndConditions"
        :key="`modal-${tac.term_and_condition_id}`"
        v-model="isOpen(`term-modal-${tac.term_and_condition_id}`).value"
    >
        <template #title>
            <h4 class="tw-text-lg tw-font-semibold tw-mb-4">{{ tac.name }}</h4>
        </template>

        <div class="tw-max-h-96 tw-overflow-y-auto tw-pr-2">
            <div v-html="tac.conditions_text" class="tw-text-sm tw-leading-relaxed"></div>
        </div>

        <template #footer>
            <div class="tw-flex tw-justify-end tw-mt-6">
                <button
                    @click="closeTermModal(tac.term_and_condition_id)"
                    class="tw-px-4 tw-py-2 tw-bg-gray-500 tw-text-white tw-rounded hover:tw-bg-gray-600 tw-transition-colors"
                >
                    Close
                </button>
            </div>
        </template>
    </VModal>
</template>
